<template>
  <div class="scenicParkDetail">
    <loading v-if="isLoading"></loading>
    <div v-else>
      <!-- 顶部打开app -->
      <openAppDialog
        ref="openApp"
        :title="openTitle"
        :shareId="shareId"
        :shareType="shareType"
        isShow="true"
        @openApp="openApp()"
      ></openAppDialog>
      <div v-if="!emptyShow">
        <!-- banner -->
        <div class="banner_container">
          <van-image
            class="banner_img"
            :src="bannerData.src"
            width="100%"
             fit="contain"
          />
          <div class="banner_shadow"></div>
          <div class="banner_content">
            <div class="content_title">{{ bannerData.name }}</div>
            <div class="content_desc">
              <div
                class="content_label"
                v-for="(item, index) in bannerData.tags"
                :key="index"
              >{{ item }}</div>
            </div>
            <div class="content_images" @click="showApp">
              <div>
                <img src="../../assets/img/imageLength_icon.png" alt />
                <div>{{ bannerData.imageLength }}图</div>
              </div>
            </div>
          </div>
          <div class="banner_bottom">
            <div class="banner_bottom_box">
              <div
                class="bottom_item"
                v-for="(item, index) in bannerData.scenicTraits"
                :key="index"
              >
                <div class="bottom_title">{{ item.title }}</div>
                <div class="bottom_desc">{{ item.subTitle }}</div>
              </div>
              <!-- <div class="bottom_item">
                <div class="bottom_title">值得去</div>
                <div class="bottom_desc">儿童攀爬基地皮划艇中心</div>
              </div>
              <div class="bottom_item">
                <div class="bottom_title">怎么玩</div>
                <div class="bottom_desc">68%市民来运动健身27%市民来遛娃</div>
              </div>-->
            </div>
          </div>
        </div>
        <!-- banner end -->
        <!-- bottom -->
        <div class="container">
          <div class="container_top"></div>
          <div class="container_icon">
            <div class="location_container">
              <div class="location_left">
                <div class="locationLeft_top">
                  <div class="top_left">{{ locationData.address }}</div>
                  <div
                    class="top_right"
                    v-if="isShowDistance"
                  >距你{{ distance(locationData.lat, locationData.lng) }}</div>
                </div>
                <div class="locationLeft_bottom">{{ locationData.stationInfo }}</div>
              </div>
              <div class="location_right" @click="showApp">
                <img src="../../assets/img/goHere_icon_orange.png" alt />
              </div>
            </div>

            <!-- 园内讲解 -->
            <div class="explain_container">
              <div class="top_icon">
                <!-- <div class="topIcon_item">
                  <img src="../../assets/img/goHere_icon_orange.png" alt="">
                  <div class="text">园内导航</div>
                </div>-->
                <div class="topIcon_item" @click="showApp">
                  <img src="../../assets/img/scenic_park_icon.png" alt />
                  <div class="text">停车场</div>
                </div>
                <div v-if="audioWoMan || audioMan" class="topIcon_item" @click="showApp">
                  <img src="../../assets/img/say_icon.png" alt />
                  <div class="text">讲解</div>
                </div>
              </div>

              <!-- <div class="heat_container">
                <div class="heat_left">
                  <img src="../../assets/img/goHere_icon_orange.png" alt="">
                  <div>实时：600-700人在园区</div>
                </div>
                <div>查看热力图</div>
              </div>-->

              <div class="bottom_icon" v-if="facilities.length > 0">
                <div class="bottom_item" v-for="(item, index) in facilities" :key="index">
                  <van-image width="14px" height="12px" fit="cover" lazy-load :src="item.icon" />
                  <div class="item_text">{{ item.name }}</div>
                </div>
              </div>
            </div>
            <!-- 园内讲解 end-->
          </div>

          <!-- 必玩内容 -->
          <div class="recommend_container" v-if="mustPlayArr.length > 0">
            <div class="recommend_title">
              <div class="title_left">必玩内容</div>
              <div class="title_right" @click="showApp">
                <span>全部</span>
                <van-icon name="arrow" slot="left" />
              </div>
            </div>
            <div class="tab_box" v-if="tabArray.length > 1">
              <tab-checkout :array="tabArray" :activeIndex="tabActive" @itemClick="showApp"></tab-checkout>
            </div>
            <div class="list_container">
              <swiper
                :options="{
                  slidesPerView: 2.2,
                  spaceBetween: 12,
                  slidesOffsetAfter: 20,
                }"
                ref="mySwiper"
              >
                <swiper-slide class="list_item" v-for="(item, index) in mustPlayArr" :key="index">
                  <div @click="showApp">
                    <van-image
                      v-if="tabType == 1"
                      radius="3px"
                      width="150px"
                      height="100px"
                      fit="cover"
                      lazy-load
                      :src="item.coverImg"
                    />
                    <van-image
                      v-if="tabType == 4"
                      radius="3px"
                      :width="150"
                      :height="100"
                      lazy-load
                      :src="item.cover_img"
                    />
                    <van-image
                      v-if="tabType == 3"
                      radius="3px"
                      width="150px"
                      height="100px"
                      fit="cover"
                      lazy-load
                      :src="item.imageList[0]"
                    />
                    <div class="title">{{ item.name }}</div>
                    <div class="tags_container" v-if="item.tags && tabType == 1">
                      <div class="tags" v-for="(item, index) in item.tags" :key="index">{{ item }}</div>
                    </div>
                    <div
                      class="tags_container"
                      v-if="
                        item.tags != null &&
                          item.tags != 'null' &&
                          item.tags &&
                          tabType == 4
                      "
                    >
                      <div
                        class="tags"
                        v-for="(item, index) in item.tags.split(',')"
                        :key="index"
                      >{{ item }}</div>
                    </div>
                    <div class="tags_container" v-if="item.tags && tabType == 3">
                      <div class="tags" v-for="(item, index) in item.tags" :key="index">{{ item }}</div>
                    </div>
                    <div
                      class="label_component"
                      v-if="isShowDistance"
                    >距你{{ distance(item.latitude, item.longitude) }}</div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
          <!-- 必玩内容 end -->
          <!-- 路线推荐 -->
          <div class="recommend_container line_box" v-if="recommendArr.length > 0">
            <div class="recommend_title">
              <div class="title_left">路线推荐</div>
              <div class="title_right" @click="showApp">
                <span>全部</span>
                <van-icon name="arrow" slot="left" />
              </div>
            </div>

            <div class="list_container">
              <swiper
                :options="{
                  slidesPerView: 2.2,
                  spaceBetween: 12,
                  slidesOffsetAfter: 20,
                }"
                ref="mySwiper"
              >
                <swiper-slide class="list_item" v-for="(item, index) in recommendArr" :key="index">
                  <div @click="showApp">
                    <van-image
                      radius="3px"
                      width="150px"
                      height="100px"
                      fit="cover"
                      lazy-load
                      :src="item.imageUrl"
                    />
                    <div class="title">{{ item.title }}</div>
                    <div class="tags_container" v-if="item.tags && tabType == 1">
                      <div
                        class="tags"
                        v-for="(item, index) in item.tags.split(',')"
                        :key="index"
                      >{{ item }}</div>
                    </div>
                    <div
                      class="label_component"
                      v-if="isShowDistance"
                    >距你{{ distance(item.latitude, item.longitude) }}</div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
          <!-- 路线推荐 end -->

          <!-- 官方攻略 start -->
          <div class="strategy_container" v-if="strategyArr.length > 0">
            <div class="strategy_title">
              <div class="title_left">官方攻略</div>
              <div class="title_right" @click="showApp">
                <span>全部</span>
                <van-icon name="arrow" slot="left" />
              </div>
            </div>
            <!-- <swiper :options="{slidesPerView: 1.15, spaceBetween: 0}" ref="mySwiper"> -->
            <!-- <swiper-slide class="" v-for="(item,index) in delicacyArr" :key="index"> -->
            <left-img
              v-for="(item, index) in strategyArr"
              :item="item"
              @itemClick="showApp"
              :key="index"
            ></left-img>
            <!-- </swiper-slide> -->
            <!-- </swiper> -->
          </div>
          <!-- 官方攻略 end -->

          <!-- 最佳拍摄点 -->
          <div class="strategy_container" v-if="strategyArr.length > 0">
            <div class="strategy_title">
              <div class="title_left">最佳拍摄点</div>
              <div class="title_right" @click="showApp">
                <span>全部</span>
                <van-icon name="arrow" slot="left" />
              </div>
            </div>
            <div class="best_container">
              <div class="best_item" v-for="(item, index) in bestArr" :key="index" @click="showApp">
                <div class="item_left" :style="{ width: '66px' }">
                  <van-image
                    radius="3px"
                    width="66px"
                    height="66px"
                    fit="cover"
                    lazy-load
                    :src="item.imageUrl"
                  />
                </div>
                <div class="item_right">
                  <div class="title">{{ item.title }}</div>
                  <div class="distance">
                    <span
                      class="distance"
                      v-if="isShowDistance"
                    >距你{{ distance(item.latitude, item.longitude) }}</span>
                    <span class="location">{{ item.address }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 最佳拍摄点 end -->

          <!-- 用户评论 -->
          <div class="comment-box">
            <van-cell title="精彩点评" is-link :value="'全部 ' + CommentNum + ' 条热评'" @click="showApp" />
            <div class="comment-list" v-if="CommentNum !== 0">
              <customListView
                :arraydata="commentList"
                @itemDianZan="showApp"
                @itemClick="showApp"
                @bigPictureLook="showApp"
                @itemReply="showApp"
              ></customListView>
            </div>
            <div class="list-no" v-if="CommentNum === 0">
              <p>来发表第一条评论吧~</p>
            </div>
            <div class="btn">
              <van-button color="#2EBA73" @click="showApp">写点评</van-button>
            </div>
          </div>

          <div>
            <writeComment ref="writeComment" @Fb="showApp" id="modalId"></writeComment>
          </div>

          <div>
            <displayimage ref="displayimage"></displayimage>
          </div>
          <!-- 用户评论 end -->

          <!-- 附近推荐 -->
          <div
            class="recommend_container"
            :style="{ paddingBottom: 20 + 'px' }"
            v-if="aroundData.length > 0"
          >
            <div class="recommend_title">
              <div class="title_left">附近推荐</div>
            </div>
            <div class="tab_box" v-if="aroundTabArray.length > 1">
              <tab-checkout
                :array="aroundTabArray"
                :activeIndex="aroundTabActive"
                @itemClick="showApp"
              ></tab-checkout>
            </div>
            <div class="best_container">
              <div
                class="best_item"
                v-for="(item, index) in aroundData"
                :key="index"
                @click="showApp"
              >
                <div class="item_left" :style="{ width: '99px' }">
                  <van-image
                    radius="3px"
                    width="99px"
                    height="66px"
                    fit="cover"
                    lazy-load
                    :src="item.coverImg"
                  />
                </div>
                <div class="item_right">
                  <div class="title item_title">{{ item.name }}</div>
                  <div class="label_box">
                    <div class="label" v-for="(item, index) in item.tags" :key="index">{{ item }}</div>
                  </div>
                  <div class="distance">
                    <span class="location">全程28公里</span>
                    <span class="distance" v-if="isShowDistance">
                      &nbsp;&nbsp;|&nbsp;&nbsp;距你{{
                      distance(item.latitude, item.longitude)
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 附近推荐 end -->
        </div>
        <!-- bottom end -->
      </div>
      <empty
        v-else
        ref="emptyView"
        :toastTitle="toastTitle"
        :emptyShow="emptyShow"
        :style="{ top: emptyTop }"
      ></empty>
    </div>
  </div>
</template>

<script>
import openAppDialog from "@/components/openAppTopDialog.vue";
import Loading from "@/components/loading";
import writeComment from "@/components/writeComment.vue";
import customListView from "@/components/customListViewComment.vue";
import displayimage from "@/components/displayImage.vue";
import empty from "@/components/empty.vue";
// eslint-disable-next-line no-irregular-whitespace
import Vue from "vue";
// eslint-disable-next-line no-irregular-whitespace
import { Lazyload } from "vant";

Vue.use(Lazyload);

export default {
  name: "line_list",
  data() {
    return {
      openTitle: "打开天府绿道APP<br/>欣赏更多精彩景区",
      shareId: this.$route.query.id,
      shareType: "",
      toastTitle: "糟糕,数据找不到了",
      emptyShow: false,
      emptyTop: "46px",
      isPageError: false,
      isLoading: true,
      // banner 数据
      bannerData: {
        type: 1,
        src: "",
      },
      // 必玩内容 tab
      tabArray: [],
      tabActive: 0,
      // 必玩数据源
      mustPlayArr: [],
      // 必玩总数据
      allRecArr: [],
      tabType: 0,
      // 线路推荐 数据源
      recommendArr: [],
      // 官方攻略 数据源
      strategyArr: [],
      // 最佳拍摄点 数据源
      bestArr: [],
      CommentNum: 0, // 评论条数
      commentList: [],
      locationData: {},
      scenicId: "",
      lat: "",
      lng: "",
      //附近推荐
      aroundTabArray: [],
      aroundData: [],
      allATbArr: [],
      aroundTabActive: 0,
      facilities: [],
      isShowDistance: false,
      // 全局音频组件所在vue实例对象 (App.vue)
      App: this.$root.$children[0],
      audioMan: "",
      audioWoMan: "",
      audioTitle: "",
    };
  },
  components: {
    Loading,
    writeComment,
    customListView,
    displayimage,
    openAppDialog,
    empty,
  },
  watch: {
    $route() {
      this.$router.go(0);
    },
  },
  mounted() {
    this.lat = this.$route.query.lat;
    this.lng = this.$route.query.lng;
    this.scenicId = this.$route.query.id;
    this.uid = this.$cookie.get("w_uid") || "";
    this.isShowDistance = Boolean(sessionStorage.getItem("isShowDistance"));
    this.getScenicDetail();
    this.getRecommendList();
    this.getCommentList();
  },
  methods: {
    showApp() {
      this.$refs.openApp.showToast();
    },
    openApp() {
      //打开APP,跳转到APP
      //eslint-disable-next-line
      console.log("openApp()");
    },
    /**
     * 讲解click事件
     */
    palyAudio() {
      this.App.audioWoMan = this.audioWoMan == "[]" ? "" : this.audioWoMan;
      this.App.audioMan = this.audioMan == "[]" ? "" : this.audioMan;
      this.App.audioTitle = this.audioTitle;
      this.App.palyAudio();
    },

    /**
     * 图集页面
     */
    toAllPic() {
      // console.log('图集页面');
      // console.log(JSON.stringify(this.bannerData.images), 'imageList');
      // console.log(JSON.stringify(this.bannerData.video), 'video');
      this.$router.push({
        name: "newAllVideoPictures",
        query: {
          images: JSON.stringify(this.bannerData.images),
          video: JSON.stringify(this.bannerData.video),
        },
      });
    },

    /**
     * 拍摄点详情
     */
    toBestDetail(item) {
      // console.log(item, 'itemitemitemitem');
      this.$router.push({
        name: "bestShotDetail",
        query: {
          id: item.filmId,
          lat: this.$route.query.lat,
          lng: this.$route.query.lng,
        },
      });
    },
    /**
     * 获取景区详情数据
     */
    getScenicDetail() {
      this.$http
        .get(`/appserver/v1/scenic/detail?scenicId=${this.scenicId}`)
        .then((res) => {
          if (res.data.ret == 0 && res.data.data != null) {
            let resData = res.data.data;
            // console.log(resData);
            this.isLoading = false;
            this.detailData = resData;
            // console.log(resData.imageList, 'resData.imageList')
            // banner区域数据
            this.bannerData = {
              src: resData.banner,
              name: resData.name,
              tags: resData.tags,
              imageLength: resData.imageList.length,
              scenicTraits: resData.scenicTraits,
              video: resData.video, // 视频集合
              images: resData.imageList, // 图片集合
            };
            this.locationData = {
              address: resData.address,
              lat: resData.latitude,
              lng: resData.longitude,
              stationInfo: resData.stationInfo,
            };
            // 音频组件赋值
            this.audioMan =
              resData.audio.voiceMan == "[]" ? "" : resData.audio.voiceMan;
            this.audioWoMan =
              resData.audio.voiceWoman == "[]" ? "" : resData.audio.voiceWoman;
            this.audioTitle = resData.name;

            this.facilities = resData.facilities ? resData.facilities : [];
            // 必玩数据存在
            if (resData.mustPlay) {
              // tags 数据获取
              let tabArray = [];
              for (let i in resData.mustPlay.tags) {
                if (resData.mustPlay.tags[i].type != 4) {
                  tabArray.push({
                    tagName: resData.mustPlay.tags[i].name,
                    id: resData.mustPlay.tags[i].type,
                  });
                }
              }
              if (tabArray.length > 0) {
                this.tabType = tabArray[0].id;
              }
              this.tabArray = tabArray;

              // 数组 数据源
              this.allRecArr.push(resData.mustPlay.activityList);
              this.allRecArr.push(resData.mustPlay.scenicSpotList);
              // this.allRecArr.push(resData.mustPlay.foodList);
              this.mustPlayArr = resData.mustPlay.activityList
                ? resData.mustPlay.activityList
                : [];
            }
            // 线路推荐数据存在
            if (resData.route) {
              this.recommendArr = resData.route;
            }
            // 官方攻略数据
            if (resData.strategy) {
              this.strategyArr = resData.strategy;
            }
            // 最佳拍摄点 数据
            if (resData.bestFilmAddr) {
              this.bestArr = resData.bestFilmAddr;
            }
          } else {
            this.isLoading = false;
            this.toastTitle = "糟糕,数据找不到了";
            this.emptyShow = true;
          }
        })
        .catch(() => {
          // console.log(e);
          this.isLoading = false;
          this.toastTitle = "网络出错,请稍后再试!";
          this.emptyShow = true;
        });
    },

    /**
     * 去停车场
     */
    toParkingIndex() {
      this.$router.push({
        path: "/parking",
        query: {
          type: 2,
          lat: this.lat,
          lng: this.lng,
        },
      });
    },
    /**
     * 获取附近推荐
     */
    getRecommendList() {
      this.$http
        .get(
          `/appserver/v1/scenic/recommend?scenicId=${this.scenicId}&pageSize=3`
        )
        .then((res) => {
          if (res.data.ret == 0) {
            let resData = res.data.data;
            // console.log(resData);
            let tabArray = [];

            for (let i in resData.tags) {
              if (resData.tags[i].type !== 3 && resData.tags[i].type !== 4) {
                tabArray.push({
                  tagName: resData.tags[i].name,
                  id: resData.tags[i].type,
                });
              }
            }
            this.aroundTabArray = tabArray;
            // 数组 数据源
            this.allATbArr.push(resData.scenicSpot);
            this.allATbArr.push(resData.scenic);

            // this.allRecArr.push(resData.mustPlay.foodList);
            if (resData.scenicSpot) {
              this.aroundData = resData.scenicSpot;
            } else {
              this.aroundData = resData.scenic;
            }
          }
        })
        .catch(() => {
          // console.log(e);
        });
    },
    /**
     * tab 标签点击事件
     */
    tabCheckout(data) {
      this.tabActive = data.index;
      this.tabType = data.id;
      // 不太好，后期优化
      if (this.tabType == 1) {
        // 活动
        this.mustPlayArr = this.allRecArr[0];
      } else if (this.tabType == 3) {
        // 景点
        this.mustPlayArr = this.allRecArr[1];
      } else if (this.tabType == 4) {
        // this.mustPlayArr = this.allRecArr[1];
      }
    },
    /**
     * 附近推荐 tab切换
     */
    aroundTabCheckout(data) {
      this.aroundTabActive = data.index;
      this.aroundData = this.allATbArr[data.index];
    },
    /**
     * 计算距离你多少距离
     * @params lat lng 景区 景点 经纬度
     */
    distance(lat, lng) {
      if (this.$route.query.lat && this.$route.query.lng) {
        let obj = this.getDistance(
          lat,
          lng,
          this.$route.query.lat,
          this.$route.query.lng
        );
        return obj.distance.toFixed(1) + (obj.type == "km" ? "公里" : "米");
      } else {
        // return { distance: '', text: '' };
        return "0米";
      }
    },
    /**
     * 必玩点击进入详情
     */
    toMustItem(item) {
      if (this.tabType == 1) {
        //活动
        this.$router.push({
          name: "activityDetails",
          query: {
            id: item.id,
          },
        });
      } else if (this.tabType == 3) {
        //景点
        this.$router.push({
          name: "scenicSpot",
          query: {
            id: item.scenicId,
            lat: this.lat,
            lng: this.lng,
          },
        });
      }
      // this.$router.push({
      //   name: 'toastWait'
      // });
    },

    /**
     * 根据 type 跳转相应的详情页
     */

    toDetail(type, id) {
      if (type == 3) {
        //景点
        this.$router.push({
          name: "scenicSpot",
          query: {
            id: id,
            lat: this.lat,
            lng: this.lng,
          },
        });
      } else if (type == 5) {
        // 线路
        this.$router.push({
          path: "/lineDetails",
          query: {
            id: id,
            lat: this.lat,
            lng: this.lng,
          },
        });
      } else if (type == 4) {
        // 攻略
        this.$router.push({
          path: "/strategyDetails",
          query: {
            id: id,
            lat: this.lat,
            lng: this.lng,
          },
        });
      } else if (type == 7) {
        // 活动
        this.$router.push({
          name: "activityDetails",
          query: {
            id: id,
          },
        });
      } else if (type == 2) {
        // 景区
        this.$router.push({
          name: "scenicParkDetail",
          query: {
            id: id,
            lat: this.lat,
            lng: this.lng,
          },
        });
      } else {
        if (type == 8) {
          // 赛事
          window.location.href = this.SHDetails + id;
        }

        // console.log(type, 'toastWait');
        // console.log(id, 'toastWait');
      }
    },

    /**
     * 路线推荐点击进入详情
     */
    toRecommendItem(id, item) {
      // console.log(item, '进入详情页');
      this.$router.push({
        path: "/lineDetails",
        query: {
          id: item.id,
          lat: this.lat,
          lng: this.lng,
        },
      });
    },

    /**
     * 附近推荐
     */
    toAroundRecommend(item) {
      // console.log(item, 'itemitmeitemitmeitmeitme');
      if (item.type == 1) {
        // 公园
        this.$router.push({
          name: "scenicParkDetail",
          query: {
            id: item.id,
            lat: this.lat,
            lng: this.lng,
          },
        });
      } else if (item.type == 2) {
        // 景点
        this.$router.push({
          name: "scenicSpot",
          query: {
            id: item.id,
            lat: this.lat,
            lng: this.lng,
          },
        });
      }
    },
    /**
     * 官方攻略点击进入详情
     */
    toStrategyItem(id) {
      // console.log(item, '进入详情页')
      this.$router.push({
        path: "/strategyDetails",
        query: {
          id: id,
          lat: this.lat,
          lng: this.lng,
        },
      });
    },

    /**
     * 更多玩法 item 点击
     */
    toMoreItem() {
      // console.log('进入详情页')
      this.$router.push({
        name: "toastWait",
      });
    },
    /**
     * 跳转全部列表事件
     */
    toAllList(event, name) {
      // console.log(name, 'allList');
      // 必玩列表
      if (name == "mustPlay") {
        this.$router.push({
          name: "mustPlayList",
          query: {
            scenicId: this.scenicId,
            lat: this.lat,
            lng: this.lng,
            isPark: true, // 判断是否由景区名片而来
            listType: this.tabArray[this.tabActive].id,
          },
        });
      }
      //主题线路
      if (name == "recommend") {
        this.$router.push({
          name: "lineList",
          query: {
            scenicId: this.scenicId,
            lat: this.lat,
            lng: this.lng,
            dataType: 2,
          },
        });
      }
      // 官方攻略
      if (name == "strategy") {
        this.$router.push({
          name: "newStrategyList",
          query: {
            scenicId: this.scenicId,
            dataType: 2, // 2 代表是由景区名片进入的
          },
        });
      }
      if (name == "best") {
        this.$router.push({
          name: "baseShotList",
          query: {
            id: this.scenicId,
            lat: this.lat,
            lng: this.lng,
          },
        });
      }
    },
    /**
     * 跳转至导航页
     */
    toMap(lat, lng, location, address) {
      window.location.href =
        "http://apis.map.qq.com/tools/poimarker?type=0&marker=coord:" +
        lat +
        "," +
        lng +
        ";title:" +
        location +
        ";addr:" +
        address +
        "&key=LJKBZ-2WTRW-JT7RQ-OSONW-ZO6X7-ZMFMG&referer=myapp";
    },

    /**
     * 获取评论
     */
    getCommentList() {
      let fromData = new FormData();
      // console.log(this.scenicId, 'this.grenen')
      fromData.append("cid", this.scenicId);
      fromData.append("type", "scenic_card");
      this.$http.post(`/appserver/v1/comment/list`, fromData).then((data) => {
        let _data = data.data.data;
        if (_data.list && _data.list.length !== 0) {
          this.commentList = _data.list;
        }
        this.CommentNum = _data.comment_num; // 评论条数
      });
    },

    /**
     * 用户点赞回调
     */
    itemDianZan(item, commId) {
      if (!this.uid) {
        this.wxAuth();
        return;
      }
      // let data = {
      //   comment_id: commId,
      //   number: "1",
      // };
      let fromData = new FormData();
      fromData.append("comment_id", commId);
      fromData.append("number", 1);
      this.$http
        .post(`/appserver/v1/comment/deleteOrUp`, fromData, {
          headers: {
            uid: this.uid,
          },
        })
        .then((data) => {
          if (data.data.ret === 0) {
            item.up++;
            item.is_up = !item.is_up;
          } else {
            this.$toast(data.data.msg);
          }
        });
    },

    /**
     * 回复
     * @params item 回复的评论item commId  回复的commitId
     */
    itemReply(item, commId) {
      this.parentId = commId;
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        let windheight = document.documentElement.clientHeight; //为唤起软键盘时当前窗口高度
        document.getElementById("modalId").style.position = "relative";
        window.onresize = function () {
          var docheight = document.documentElement.clientHeight; //唤起软键盘时窗口高度
          document.getElementById("write").style.bottom =
            docheight - windheight + "px";
        };
      }
      if (this.uid) {
        this.$refs.writeComment.showWriteDialog();
      } else {
        this.wxAuth();
      }
    },

    // 用户评论列表
    AllDiscussList() {
      if (this.CommentNum <= 0) {
        return;
      } else {
        this.$router.push({
          path: "/allDiscussList",
          query: {
            cid: this.scenicId,
            type: "scenic_card",
          },
        });
      }
    },
    // 评论详情
    Details(item) {
      this.$router.push({
        path: "/discussDetails",
        query: {
          comment_id: item.comment_id,
          type: "scenic_card",
          from: "web",
        },
      });
    },
    // 图片点击放大
    BigPictureLook(item, index) {
      this.$refs.displayimage.showBigPictureLook(item.image, index);
    },
    // 写评论
    Write() {
      // 确保parentId为空，不是回复操作
      this.parentId = null;
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        let windheight = document.documentElement.clientHeight; //为唤起软键盘时当前窗口高度
        document.getElementById("modalId").style.position = "relative";
        window.onresize = function () {
          var docheight = document.documentElement.clientHeight; //唤起软键盘时窗口高度
          document.getElementById("write").style.bottom =
            docheight - windheight + "px";
        };
      }
      if (this.uid) {
        this.$refs.writeComment.showWriteDialog();
      } else {
        this.wxAuth();
      }
    },
    // 发表
    Fb(msg) {
      var message = msg[0];
      var gallerysStr = msg[1];
      let fromData = new FormData();
      fromData.append("content", message);
      fromData.append("cid", this.scenicId);
      fromData.append("ctitle", document.title);
      fromData.append("type", "scenic_card");
      fromData.append("source_type", "h5");
      fromData.append("image", gallerysStr);

      if (this.parentId) {
        fromData.append("parent_id", this.parentId);
      }
      this.$http
        .post(`/appserver/v1/comment/addComment`, fromData, {
          headers: {
            uid: this.uid,
          },
        })
        .then((data) => {
          // console.log(data, 'asdasdasdasd');
          if (data.data.ret == 0) {
            if (this.parentId) {
              this.$toast("回复成功");
            } else {
              this.$toast("发布成功");
            }
            this.getCommentList();
            this.$refs.writeComment.ClosePost();
          } else {
            // console.log('登录过期');
            this.$refs.writeComment.ClosePost();
            if (data.data.msg == "缺少uid请登录") {
              this.wxAuth();
            } else {
              this.$toast(data.data.msg);
            }
          }
        });
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.scenicParkDetail {
  .banner_container {
    position: relative;
    .banner_content {
      position: absolute;
      top: 78px;
      left: 21px;
      color: white;
      z-index: 2;
      .content_title {
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 5px;
      }
      .content_desc {
        div {
          display: inline-block;
        }
        .content_label {
          border: 1px solid #e6c693;
          color: #e6c693;
          padding: 2px 5px;
          font-size: 14px;
          border-radius: 2px;
          font-weight: 500;
          margin-right: 4px;
        }
      }
      .content_images {
        display: inline-block;
        width: 50px;
        height: 20px;
        line-height: 20px;
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.5);
        color: white;
        font-size: 12px;
        margin-top: 5px;
        div {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        img {
          width: 11px;
          height: 9px;
          margin-right: 4px;
        }
      }
    }
    .banner_bottom {
      position: absolute;
      bottom: 15px;
      left: 21px;
      color: white;
      z-index: 2;
      .banner_bottom_box {
        display: flex;
        justify-content: space-between;
        width: calc(100vw - 40px);
        padding-bottom: 16px;
        .bottom_item {
          padding-right: 18px;
          font-size: 12px;
          .bottom_title {
            font-size: 13px;
            color: #e6c693;
            margin-bottom: 8px;
          }
        }
      }
    }
    .banner_shadow {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 260px;
      background: linear-gradient(to bottom, #ccc, black);
      opacity: 0.5;
      z-index: 1;
    }
  }
  .container {
    position: relative;
    background: white;
    .container_top {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 15px;
      border-radius: 15px 15px 0px 0px;
      transform: translateY(-15px);
      background: white;
      z-index: 2;
    }
    .container_icon {
      padding: 0 20px;
      .location_container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding-bottom: 12px;
        .location_left {
          display: flex;
          flex-direction: column;
          font-size: 12px;
          color: #262626;
          padding-left: 5px;
          .locationLeft_top {
            display: flex;
            .top_right {
              margin-left: 10px;
              color: #2eba73;
            }
          }
          .locationLeft_bottom {
            margin-top: 5px;
            color: #bfbfbf;
          }
        }
        .location_right {
          width: 50px;
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-left: 1px solid #e5e5e5;
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
      .explain_container {
        .top_icon {
          width: 100%;
          height: 100px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .topIcon_item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
              width: 28px;
              height: 28px;
            }
            .text {
              font-size: 12px;
              color: #000;
              margin-top: 6px;
            }
          }
        }
        .heat_container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          height: 30px;
          background: #eaf8f0;
          color: #2eba73;
          font-size: 12px;
          padding: 0px 5px;
          border-radius: 3px;
          .heat_left {
            display: flex;
            align-items: center;
            img {
              width: 44px;
              height: 20px;
            }
            div {
              margin-left: 15px;
            }
          }
        }
        .bottom_icon {
          display: flex;
          width: 100%;
          // height: 64px;
          align-items: flex-start;
          // justify-content: space-between;
          margin-top: 10px;
          background: #eaf8f0;
          color: rgba(0, 0, 0, 0.85);
          padding: 0px 5px;
          border-radius: 3px;
          flex-wrap: wrap;
          padding-bottom: 16px;
          .bottom_item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-left: 12px;
            padding-right: 12px;
            padding-top: 14px;
            width: 20%;
            box-sizing: border-box;
            img {
              width: 10px;
              height: 12px;
            }
            .item_text {
              font-size: 10px;
              margin-top: 6px;
              color: rgba(0, 0, 0, 0.85);
            }
          }
        }
      }
    }
  }

  .recommend_container {
    // .list_container {
    // }
    margin-top: 40px;
    padding-left: 20px;
    .right_like {
      color: rgba(0, 0, 0, 0.5);
      font-size: 11px;
    }
    .label_component {
      font-size: 11px;
      color: #787878;
      margin-top: 4px;
    }
    .mustPlay_title,
    .recommend_title,
    .delicacy_title,
    .strategy_title,
    .waterfall_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 20px;
      margin-bottom: 20px;
      .title_left {
        font-size: 20px;
        font-weight: 400;
      }
      .title_right {
        display: flex;
        align-items: center;
        span {
          margin-right: 10px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.5);
        }
      }
      .title_tag {
        display: flex;
        align-items: center;
        white-space: nowrap;
        width: 100%;
        overflow-x: auto;
        ::-webkit-scrollbar {
          width: 0px;
        }
        .tag_item {
          margin-right: 30px;
          font-size: 16px;
          color: #787878;
          padding-bottom: 5px;
          cursor: pointer;
          width: initial;
        }
        .tag_item_active {
          font-size: 20px;
          color: #000000;
          position: relative;
          .item_line {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 4px;
            background: #2ed07e;
            border-radius: 2px;
          }
        }
      }
    }
    .strategy_title {
      padding-right: 0;
    }
    .tab_box {
      margin-bottom: 20px;
    }
    .list_container {
      .title {
        font-size: 14px;
        font-weight: 700;
        color: #262626;
        margin-top: 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .date,
      .address {
        font-size: 11px;
        color: rgba(0, 0, 0, 0.25);
        margin-top: 4px;
      }
      .tags_container {
        display: flex;
        .tags {
          margin-right: 3px;
          margin-top: 4px;
          padding: 2px 4px;
          background: rgba(97, 69, 247, 0.15);
          color: #6145f7;
          font-size: 11px;
        }
      }
    }
  }
  .strategy_container {
    padding-right: 20px;
  }
  .line_box {
    padding-bottom: 40px;
  }
  .strategy_container,
  .recommend_container {
    margin-top: 40px;
    padding-left: 20px;

    // padding-right: 20px;
    .best_container {
      .best_item {
        display: flex;
        margin-bottom: 25px;
        .item_right {
          margin-left: 18px;
          .title {
            font-size: 16px;
            color: #262626;
            font-weight: 700;
            margin-bottom: 8px;
          }
          .item_title {
            margin-bottom: 4px;
          }
          .distance {
            font-size: 12px;
            color: #787878;
            // letter-spacing: 0.5px;
            // display: flex;
            // align-items: center;
            .location {
              margin-left: 4px;
            }
          }
          .label_box {
            display: flex;
            margin-bottom: 6px;
            .label {
              padding: 2px 5px;
              background: rgba(97, 69, 247, 0.15);
              border-radius: 2px;
              color: #6145f7;
              margin-right: 4px;
            }
          }
        }
      }
    }
    .right_like {
      color: rgba(0, 0, 0, 0.5);
      font-size: 11px;
    }
    .tags_container {
      display: flex;
      flex-wrap: wrap;
      max-height: 20px;
      overflow: hidden;
      margin-bottom: 4px;
      .tags {
        margin-right: 3px;
        padding: 1px 3px;
        background: rgba(0, 0, 0, 0.05);
        color: #787878;
        font-size: 11px;
      }
    }
    .label_component {
      font-size: 11px;
      color: #2eba73;
      margin-top: 4px;
    }
    .strategy_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 20px;
      margin-bottom: 20px;
      .title_left {
        font-size: 20px;
        font-weight: 400;
      }
      .title_right {
        display: flex;
        align-items: center;
        span {
          margin-right: 10px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.5);
        }
      }
      .title_tag {
        display: flex;
        align-items: center;
        white-space: nowrap;
        width: 100%;
        overflow-x: auto;
        ::-webkit-scrollbar {
          width: 0px;
        }
        .tag_item {
          margin-right: 30px;
          font-size: 16px;
          color: #787878;
          padding-bottom: 5px;
          cursor: pointer;
          width: initial;
        }
        .tag_item_active {
          font-size: 20px;
          color: #000000;
          position: relative;
          .item_line {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 4px;
            background: #2ed07e;
            border-radius: 2px;
          }
        }
      }
    }
    .strategy_title {
      padding-right: 0;
    }
    .tab_box {
      margin-bottom: 20px;
    }
    .label {
      font-size: 11px;
      color: rgba(0, 0, 0, 0.25);
      margin-top: 4px;
      display: flex;
      .label_item {
        background: rgba(97, 69, 247, 0.15);
        color: #6e5adb;
        margin-right: 4px;
        padding: 3px 4px;
      }
    }
    .address {
      font-size: 11px;
      color: rgba(0, 0, 0, 0.25);
      margin-top: 4px;
    }
  }
  // 评论列表 start
  .comment-box {
    padding: 20px;
    border-top: 5px solid rgba(0, 0, 0, 0.05);
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    /deep/ .van-cell {
      margin: 25px 0px;
      padding: 0px;
    }
    /deep/ .van-cell__title span {
      font-size: 20px;
      font-family: PingFangTC-Medium, PingFangTC;
      font-weight: 500;
      color: rgba(55, 56, 77, 1);
    }
    /deep/ .van-cell__value {
      font-size: 15px;
      font-family: PingFangSC-Light, PingFang SC;
      // font-weight: 300;
      color: #000;
    }
    /deep/ .van-cell:not(:last-child)::after {
      border: 0px;
    }
    /deep/ .van-icon {
      color: #37384d;
      font-size: 16px;
    }
    .comment-list {
      padding: 0px;
    }
    .list-no {
      text-align: left;
      // padding: 30px 0px 0px 0px;
      & > p {
        height: 14px;
        font-size: 15px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: rgba(153, 153, 153, 1);
        line-height: 14px;
      }
    }
    .btn {
      margin-top: 29px;
      width: 100%;
      opacity: 0.95;
      margin-bottom: 24px;
      /deep/ .van-image {
        margin-right: 4px;
        margin-top: -3px;
        img {
          border-radius: 3px;
        }
      }
      /deep/ .van-button {
        width: 100%;
        border: 0px;
        height: 40px;
      }
      /deep/ .van-button span {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        /deep/ .van-icon {
          color: #fff;
          margin-right: 7px;
        }
      }
      /deep/ .van-icon {
        color: #fff;
        margin-right: 7px;
      }
    }
  }
  // 评论列表 end
}
</style>
